import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
    AccountProfileService,
    FirestorePathsService,
    DealershipService,
} from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
import type { TAccountProfile, TDealership } from '@shared/models';

@Component({
    'selector': 'app-account',
    'templateUrl': './account.page.html',
    'styleUrls': ['./account.page.scss'],
    'standalone': true,
    'imports': [ IonicModule, CommonModule, FormsModule],
})
export class AccountPage extends ViewBasePage implements OnInit, OnDestroy {
    private uid = '';
    public accountProfile: TAccountProfile = null;
    public dealership: TDealership = null;

    constructor(private activatedRoute: ActivatedRoute,
        private accountProfileService: AccountProfileService, private dealershipService: DealershipService,
        private firestorePathsService: FirestorePathsService,
        injector: Injector) {
        super(injector);
        super.setCurrentView(Constants.VIEW_ACCOUNT);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        this.accountProfile = this.accountProfileService.getNullable();
        this.dealership = this.dealershipService.getNullable();

        this.uid = this.activatedRoute.snapshot.paramMap.get('uid');
        this.firestorePathsService.setAccount(this.uid);

        // this.accountProfile = await this.accountProfileService.getProfileByAccountNumber(this.uid);
        // this.dealership = await this.dealershipService.getDealershipByAccountNumber(this.uid);
        this.accountProfile = await this.accountProfileService.get();
        this.dealership = await this.dealershipService.get();

        // if (uid) {
        //     this.uxHelperService.showSpinner();
        //     this.shuttle = await this.shuttlesService.getByUid(uid);
        //     this.uxHelperService.hideSpinner();
        // } else {
        //     this.shuttle.status = 'Idle';
        //     this.shuttle.passengerCapacity = 1;
        // }
        // console.log('accountNumber = ', this.uid);
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public onShowPage(page: string) {
        switch (page) {
            case 'accountProfile':
                this.router.navigateByUrl('/accountProfile/' + this.uid);
                break;

            case 'orders':
                this.router.navigateByUrl('/orders/' + this.uid);
                break;

            case 'users':
                this.router.navigateByUrl('/users/' + this.uid);
                break;

            case 'smsSentMessages':
                this.router.navigateByUrl('/smsSentMessages/' + this.uid);
                break;

            case 'importExport':
                this.router.navigateByUrl('/importExport');
                break;

            case 'resetCypress':
                this.firebaseFunctionsService.resetCypress();
                break;
        }
    }
}
